/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AIEnhanceCompetitionDetailsBody } from '../models';
// @ts-ignore
import type { AddCompetitionQuestionsBody } from '../models';
// @ts-ignore
import type { AddCompetitionQuestionsResponse } from '../models';
// @ts-ignore
import type { AdminUpdateRegistrationDetails } from '../models';
// @ts-ignore
import type { AnsweredQuestionsAndAnalyticsResponse } from '../models';
// @ts-ignore
import type { BanCompetitionUserResponse } from '../models';
// @ts-ignore
import type { CalibrationStatusResponse } from '../models';
// @ts-ignore
import type { CertificateDetailsByAliasResponse } from '../models';
// @ts-ignore
import type { CompetitionAnalyticsResponse } from '../models';
// @ts-ignore
import type { CompetitionContentBriefResponse } from '../models';
// @ts-ignore
import type { CompetitionContentResponse } from '../models';
// @ts-ignore
import type { CompetitionFAQItem } from '../models';
// @ts-ignore
import type { CompetitionImageUploadResponse } from '../models';
// @ts-ignore
import type { CompetitionInvitationBody } from '../models';
// @ts-ignore
import type { CompetitionInvitationResponse } from '../models';
// @ts-ignore
import type { CompetitionPublicListingBody } from '../models';
// @ts-ignore
import type { CompetitionPublishReadinessResponse } from '../models';
// @ts-ignore
import type { CompetitionRegistrationBody } from '../models';
// @ts-ignore
import type { CompetitionStartStatisticsResponse } from '../models';
// @ts-ignore
import type { DeleteAssociatedQuestionsBody } from '../models';
// @ts-ignore
import type { DeleteCompetitionResponse } from '../models';
// @ts-ignore
import type { DetailedCompetitionAnalyticsResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { EventPreferencesBody } from '../models';
// @ts-ignore
import type { GallerySubmissionsResponse } from '../models';
// @ts-ignore
import type { GenerateCertificateResponseBase } from '../models';
// @ts-ignore
import type { GenerateCompetitionProfileMatchBody } from '../models';
// @ts-ignore
import type { GenerateCompetitionQuestionsV2Body } from '../models';
// @ts-ignore
import type { GetAllCompetitionsSub } from '../models';
// @ts-ignore
import type { GetCompetitionFAQListResponse } from '../models';
// @ts-ignore
import type { GetCompetitionInvitesResponse } from '../models';
// @ts-ignore
import type { GetCompetitionListCardResponse } from '../models';
// @ts-ignore
import type { GetCompetitionQuestionsResponse } from '../models';
// @ts-ignore
import type { GetCompetitionResponse } from '../models';
// @ts-ignore
import type { GetCompetitionSchedulesResponse } from '../models';
// @ts-ignore
import type { GetCompetitionsRegistrations } from '../models';
// @ts-ignore
import type { GetUserReferralsByCompetitionResponse } from '../models';
// @ts-ignore
import type { IsAliasAvailableResponse } from '../models';
// @ts-ignore
import type { MySubmissionsResponse } from '../models';
// @ts-ignore
import type { PublicLeaderboardResponse } from '../models';
// @ts-ignore
import type { RedeemCompetitionPremiumProfileResponse } from '../models';
// @ts-ignore
import type { ReorderAssociatedQuestionsBody } from '../models';
// @ts-ignore
import type { ReplaceCompetitionQuestionBody } from '../models';
// @ts-ignore
import type { ScoreSubmissionBody } from '../models';
// @ts-ignore
import type { ScoreSubmissionResponse } from '../models';
// @ts-ignore
import type { SendCertificateBody } from '../models';
// @ts-ignore
import type { SetCalibrationSkillsBody } from '../models';
// @ts-ignore
import type { SetCalibrationSkillsResponse } from '../models';
// @ts-ignore
import type { SingleSubmissionResponse } from '../models';
// @ts-ignore
import type { StartCalibrationBody } from '../models';
// @ts-ignore
import type { StartCalibrationResponse } from '../models';
// @ts-ignore
import type { SubmissionLikeResponse } from '../models';
// @ts-ignore
import type { SubmissionTemplate } from '../models';
// @ts-ignore
import type { SubmissionTemplateListResponse } from '../models';
// @ts-ignore
import type { SuccessMsg } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UnlockCompetitionBody } from '../models';
// @ts-ignore
import type { UpsertCompetitionBody } from '../models';
// @ts-ignore
import type { UpsertCompetitionContentBody } from '../models';
// @ts-ignore
import type { UpsertCompetitionFAQBody } from '../models';
// @ts-ignore
import type { UpsertScheduleBody } from '../models';
// @ts-ignore
import type { UpsertScheduleResponse } from '../models';
// @ts-ignore
import type { UpsertSubmissionTemplateBody } from '../models';
// @ts-ignore
import type { UserCompetitionAchievementsResponse } from '../models';
/**
 * CompetitionApiApi - axios parameter creator
 */
export const CompetitionApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} competitionId 
         * @param {AddCompetitionQuestionsBody} addCompetitionQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiAddAdminCompetitionQuestions: async (competitionId: string, addCompetitionQuestionsBody: AddCompetitionQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiAddAdminCompetitionQuestions', 'competitionId', competitionId)
            // verify required parameter 'addCompetitionQuestionsBody' is not null or undefined
            assertParamExists('competitionApiAddAdminCompetitionQuestions', 'addCompetitionQuestionsBody', addCompetitionQuestionsBody)
            const localVarPath = `/admin/competition/{competition_id}/add-competition-questions`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCompetitionQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {AddCompetitionQuestionsBody} addCompetitionQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiAddCompetitionQuestions: async (competitionId: string, addCompetitionQuestionsBody: AddCompetitionQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiAddCompetitionQuestions', 'competitionId', competitionId)
            // verify required parameter 'addCompetitionQuestionsBody' is not null or undefined
            assertParamExists('competitionApiAddCompetitionQuestions', 'addCompetitionQuestionsBody', addCompetitionQuestionsBody)
            const localVarPath = `/competition/{competition_id}/add-competition-questions`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCompetitionQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiAdminCompetitionCleanupScript: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/competition-cleanup-script`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AIEnhanceCompetitionDetailsBody} aIEnhanceCompetitionDetailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiAiEnhanceCompetitionDetails: async (aIEnhanceCompetitionDetailsBody: AIEnhanceCompetitionDetailsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aIEnhanceCompetitionDetailsBody' is not null or undefined
            assertParamExists('competitionApiAiEnhanceCompetitionDetails', 'aIEnhanceCompetitionDetailsBody', aIEnhanceCompetitionDetailsBody)
            const localVarPath = `/competition/ai-enhance-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aIEnhanceCompetitionDetailsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {ReorderAssociatedQuestionsBody} reorderAssociatedQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiAssociateManualQuestions: async (competitionId: string, reorderAssociatedQuestionsBody: ReorderAssociatedQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiAssociateManualQuestions', 'competitionId', competitionId)
            // verify required parameter 'reorderAssociatedQuestionsBody' is not null or undefined
            assertParamExists('competitionApiAssociateManualQuestions', 'reorderAssociatedQuestionsBody', reorderAssociatedQuestionsBody)
            const localVarPath = `/competition/{competition_id}/associate-manual-questions`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderAssociatedQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiBanCompetitionUser: async (competitionId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiBanCompetitionUser', 'competitionId', competitionId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('competitionApiBanCompetitionUser', 'userId', userId)
            const localVarPath = `/admin/competition/{competition_id}/registrations/{user_id}/ban`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {CompetitionRegistrationBody} competitionRegistrationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiCompetitionRegistrations: async (competitionId: string, competitionRegistrationBody: CompetitionRegistrationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiCompetitionRegistrations', 'competitionId', competitionId)
            // verify required parameter 'competitionRegistrationBody' is not null or undefined
            assertParamExists('competitionApiCompetitionRegistrations', 'competitionRegistrationBody', competitionRegistrationBody)
            const localVarPath = `/competition/{competition_id}/register`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(competitionRegistrationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string | null} [title] 
         * @param {string | null} [description] 
         * @param {string | null} [projectUrl] 
         * @param {File | null} [projectFile] 
         * @param {string | null} [submissionData] 
         * @param {string | null} [sessionId] 
         * @param {string | null} [entryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiCompetitionRegistrationsEntrySubmit: async (competitionId: string, title?: string | null, description?: string | null, projectUrl?: string | null, projectFile?: File | null, submissionData?: string | null, sessionId?: string | null, entryId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiCompetitionRegistrationsEntrySubmit', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/registration/submit-entry`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }

            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }

            if (projectUrl !== undefined) { 
                localVarFormParams.append('project_url', projectUrl as any);
            }

            if (projectFile !== undefined) { 
                localVarFormParams.append('project_file', projectFile as any);
            }

            if (submissionData !== undefined) { 
                localVarFormParams.append('submission_data', submissionData as any);
            }

            if (sessionId !== undefined) { 
                localVarFormParams.append('session_id', sessionId as any);
            }

            if (entryId !== undefined) { 
                localVarFormParams.append('entry_id', entryId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {UpsertCompetitionFAQBody} upsertCompetitionFAQBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiCreateCompetitionFaq: async (competitionId: string, upsertCompetitionFAQBody: UpsertCompetitionFAQBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiCreateCompetitionFaq', 'competitionId', competitionId)
            // verify required parameter 'upsertCompetitionFAQBody' is not null or undefined
            assertParamExists('competitionApiCreateCompetitionFaq', 'upsertCompetitionFAQBody', upsertCompetitionFAQBody)
            const localVarPath = `/admin/competition/{competition_id}/faq`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertCompetitionFAQBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateCompetitionProfileMatchBody} generateCompetitionProfileMatchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiCreateCompetitionMatch: async (generateCompetitionProfileMatchBody: GenerateCompetitionProfileMatchBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateCompetitionProfileMatchBody' is not null or undefined
            assertParamExists('competitionApiCreateCompetitionMatch', 'generateCompetitionProfileMatchBody', generateCompetitionProfileMatchBody)
            const localVarPath = `/admin/competition/generate-profile-matches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateCompetitionProfileMatchBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertSubmissionTemplateBody} upsertSubmissionTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiCreateSubmissionTemplate: async (upsertSubmissionTemplateBody: UpsertSubmissionTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertSubmissionTemplateBody' is not null or undefined
            assertParamExists('competitionApiCreateSubmissionTemplate', 'upsertSubmissionTemplateBody', upsertSubmissionTemplateBody)
            const localVarPath = `/competition-submission-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSubmissionTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {DeleteAssociatedQuestionsBody} deleteAssociatedQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiDeleteAssociatedQuestions: async (competitionId: string, deleteAssociatedQuestionsBody: DeleteAssociatedQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiDeleteAssociatedQuestions', 'competitionId', competitionId)
            // verify required parameter 'deleteAssociatedQuestionsBody' is not null or undefined
            assertParamExists('competitionApiDeleteAssociatedQuestions', 'deleteAssociatedQuestionsBody', deleteAssociatedQuestionsBody)
            const localVarPath = `/competition/{competition_id}/delete-associated-questions`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAssociatedQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiDeleteCompetition: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiDeleteCompetition', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} faqId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiDeleteCompetitionFaq: async (competitionId: string, faqId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiDeleteCompetitionFaq', 'competitionId', competitionId)
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('competitionApiDeleteCompetitionFaq', 'faqId', faqId)
            const localVarPath = `/admin/competition/{competition_id}/faq/{faq_id}`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{faq_id}', encodeURIComponent(String(faqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} scheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiDeleteCompetitionSchedule: async (scheduleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleId' is not null or undefined
            assertParamExists('competitionApiDeleteCompetitionSchedule', 'scheduleId', scheduleId)
            const localVarPath = `/competition/schedule/{schedule_id}`
                .replace('{schedule_id}', encodeURIComponent(String(scheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiDeleteSubmissionTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('competitionApiDeleteSubmissionTemplate', 'templateId', templateId)
            const localVarPath = `/competition-submission-template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGenerateCertificate: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGenerateCertificate', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/generate-certificate`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {GenerateCompetitionQuestionsV2Body} generateCompetitionQuestionsV2Body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGenerateCompetitionQuestionsV2: async (competitionId: string, generateCompetitionQuestionsV2Body: GenerateCompetitionQuestionsV2Body, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGenerateCompetitionQuestionsV2', 'competitionId', competitionId)
            // verify required parameter 'generateCompetitionQuestionsV2Body' is not null or undefined
            assertParamExists('competitionApiGenerateCompetitionQuestionsV2', 'generateCompetitionQuestionsV2Body', generateCompetitionQuestionsV2Body)
            const localVarPath = `/competition/{competition_id}/generate-questions-v2`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateCompetitionQuestionsV2Body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetAdminCompetitionQuestions: async (competitionId: string, pageNo?: number, pageSize?: number, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetAdminCompetitionQuestions', 'competitionId', competitionId)
            const localVarPath = `/admin/competition/{competition_id}/get-competition-questions`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean | null} [isRegistered] 
         * @param {CompetitionApiGetAllCompetitionsLifecycleEnum} [lifecycle] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {string} [status] 
         * @param {CompetitionApiGetAllCompetitionsTypeOfCompetitionEnum} [typeOfCompetition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetAllCompetitions: async (isRegistered?: boolean | null, lifecycle?: CompetitionApiGetAllCompetitionsLifecycleEnum, page?: string, pageSize?: string, searchQuery?: string, status?: string, typeOfCompetition?: CompetitionApiGetAllCompetitionsTypeOfCompetitionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/competition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isRegistered !== undefined) {
                localVarQueryParameter['is_registered'] = isRegistered;
            }

            if (lifecycle !== undefined) {
                localVarQueryParameter['lifecycle'] = lifecycle;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (typeOfCompetition !== undefined) {
                localVarQueryParameter['type_of_competition'] = typeOfCompetition;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCalibrationStatus: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetCalibrationStatus', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/calibration/status`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} certificateAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCertificateDetailsByAlias: async (certificateAlias: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificateAlias' is not null or undefined
            assertParamExists('competitionApiGetCertificateDetailsByAlias', 'certificateAlias', certificateAlias)
            const localVarPath = `/competition/{certificate_alias}/info`
                .replace('{certificate_alias}', encodeURIComponent(String(certificateAlias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompactCompetitionAnalyticsByUser: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetCompactCompetitionAnalyticsByUser', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/user-analytics/compact`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionById: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetCompetitionById', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionContent: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetCompetitionContent', 'competitionId', competitionId)
            const localVarPath = `/admin/competition/{competition_id}/content`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionContentBrief: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetCompetitionContentBrief', 'competitionId', competitionId)
            const localVarPath = `/admin/competition/{competition_id}/content-brief`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionLeaderboard: async (competitionId: string, page?: number, pageSize?: number, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetCompetitionLeaderboard', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/leaderboard`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [name] 
         * @param {string} [ongoing] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionList: async (endDate?: string, name?: string, ongoing?: string, pageNo?: string, pageSize?: string, startDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/competition-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (ongoing !== undefined) {
                localVarQueryParameter['ongoing'] = ongoing;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionPublishReadiness: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetCompetitionPublishReadiness', 'competitionId', competitionId)
            const localVarPath = `/admin/competition/{competition_id}/publish-readiness`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortOrder] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionRegistrations: async (competitionId: string, page?: number, pageSize?: number, searchQuery?: string | null, sortBy?: string | null, sortOrder?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetCompetitionRegistrations', 'competitionId', competitionId)
            const localVarPath = `/admin/competition/{competition_id}/registrations`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [competitionId] 
         * @param {string} [competitionScheduleId] 
         * @param {string} [isActive] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionSchedules: async (competitionId?: string, competitionScheduleId?: string, isActive?: string, pageNo?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/competition/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (competitionId !== undefined) {
                localVarQueryParameter['competition_id'] = competitionId;
            }

            if (competitionScheduleId !== undefined) {
                localVarQueryParameter['competition_schedule_id'] = competitionScheduleId;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionStartStatistics: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetCompetitionStartStatistics', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/start-statistics`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionSubmissions: async (competitionId: string, page?: number, pageSize?: number, sortBy?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetCompetitionSubmissions', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/submissions`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [competitionId] 
         * @param {string} [examId] 
         * @param {string} [filterType] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchString] 
         * @param {Array<string>} [skillIds] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionUserAnsweredQuestionsAnalytics: async (competitionId?: string, examId?: string, filterType?: string, page?: number, pageSize?: number, searchString?: string, skillIds?: Array<string>, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/competition/user/answers-and-analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (competitionId !== undefined) {
                localVarQueryParameter['competition_id'] = competitionId;
            }

            if (examId !== undefined) {
                localVarQueryParameter['exam_id'] = examId;
            }

            if (filterType !== undefined) {
                localVarQueryParameter['filter_type'] = filterType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['search_string'] = searchString;
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetDetailedCompetitionAnalyticsByUser: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetDetailedCompetitionAnalyticsByUser', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/user-analytics/detailed`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetInvites: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetInvites', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/invitation`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetMySubmissions: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetMySubmissions', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/my-submissions`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean | null} [isRegistered] 
         * @param {CompetitionApiGetPrivateAllCompetitionsLifecycleEnum} [lifecycle] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {string} [status] 
         * @param {CompetitionApiGetPrivateAllCompetitionsTypeOfCompetitionEnum} [typeOfCompetition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetPrivateAllCompetitions: async (isRegistered?: boolean | null, lifecycle?: CompetitionApiGetPrivateAllCompetitionsLifecycleEnum, page?: string, pageSize?: string, searchQuery?: string, status?: string, typeOfCompetition?: CompetitionApiGetPrivateAllCompetitionsTypeOfCompetitionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/competition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isRegistered !== undefined) {
                localVarQueryParameter['is_registered'] = isRegistered;
            }

            if (lifecycle !== undefined) {
                localVarQueryParameter['lifecycle'] = lifecycle;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (typeOfCompetition !== undefined) {
                localVarQueryParameter['type_of_competition'] = typeOfCompetition;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetPublicCompetitionLeaderboard: async (competitionId: string, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetPublicCompetitionLeaderboard', 'competitionId', competitionId)
            const localVarPath = `/public/competition/{competition_id}/leaderboard`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetPublicCompetitionSubmissions: async (competitionId: string, page?: number, pageSize?: number, sortBy?: string | null, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetPublicCompetitionSubmissions', 'competitionId', competitionId)
            const localVarPath = `/public/competition/{competition_id}/submissions`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetPublicSingleSubmission: async (competitionId: string, entryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetPublicSingleSubmission', 'competitionId', competitionId)
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('competitionApiGetPublicSingleSubmission', 'entryId', entryId)
            const localVarPath = `/public/competition/{competition_id}/submission/{entry_id}`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{entry_id}', encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetSingleSubmission: async (competitionId: string, entryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetSingleSubmission', 'competitionId', competitionId)
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('competitionApiGetSingleSubmission', 'entryId', entryId)
            const localVarPath = `/competition/{competition_id}/submission/{entry_id}`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{entry_id}', encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetSubmissionTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('competitionApiGetSubmissionTemplate', 'templateId', templateId)
            const localVarPath = `/competition-submission-template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [includeArchived] 
         * @param {string | null} [orgId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetSubmissionTemplates: async (includeArchived?: boolean, orgId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/competition-submission-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeArchived !== undefined) {
                localVarQueryParameter['include_archived'] = includeArchived;
            }

            if (orgId !== undefined) {
                localVarQueryParameter['org_id'] = orgId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetUserCompetitionAchievements: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('competitionApiGetUserCompetitionAchievements', 'userId', userId)
            const localVarPath = `/public/competition/{user_id}/achievements`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetUserReferralByCompetition: async (competitionId: string, pageNo?: number, pageSize?: number, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiGetUserReferralByCompetition', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/get-user-referrals`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNo !== undefined) {
                localVarQueryParameter['page_no'] = pageNo;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {CompetitionInvitationBody} competitionInvitationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiInviteUsersCompetition: async (competitionId: string, competitionInvitationBody: CompetitionInvitationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiInviteUsersCompetition', 'competitionId', competitionId)
            // verify required parameter 'competitionInvitationBody' is not null or undefined
            assertParamExists('competitionApiInviteUsersCompetition', 'competitionInvitationBody', competitionInvitationBody)
            const localVarPath = `/competition/{competition_id}/invitation`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(competitionInvitationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} alias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiIsCompetitionAliasAvailable: async (alias: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alias' is not null or undefined
            assertParamExists('competitionApiIsCompetitionAliasAvailable', 'alias', alias)
            const localVarPath = `/competition/alias/{alias}/is-available`
                .replace('{alias}', encodeURIComponent(String(alias)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiListCompetitionFaqs: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiListCompetitionFaqs', 'competitionId', competitionId)
            const localVarPath = `/admin/competition/{competition_id}/faq`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiLockCompetition: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiLockCompetition', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/lock`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiPublicGetCompetitionById: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiPublicGetCompetitionById', 'competitionId', competitionId)
            const localVarPath = `/public/competition/{competition_id}`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiRedeemCompetitionPremiumProfile: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiRedeemCompetitionPremiumProfile', 'competitionId', competitionId)
            const localVarPath = `/competition/{competition_id}/redeem-premium-profile`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiRegenerateCompetitionInvites: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiRegenerateCompetitionInvites', 'competitionId', competitionId)
            const localVarPath = `/admin/competition/{competition_id}/regenerate-invites`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {ReorderAssociatedQuestionsBody} reorderAssociatedQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiReorderCompetitionQuestionsMapping: async (competitionId: string, reorderAssociatedQuestionsBody: ReorderAssociatedQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiReorderCompetitionQuestionsMapping', 'competitionId', competitionId)
            // verify required parameter 'reorderAssociatedQuestionsBody' is not null or undefined
            assertParamExists('competitionApiReorderCompetitionQuestionsMapping', 'reorderAssociatedQuestionsBody', reorderAssociatedQuestionsBody)
            const localVarPath = `/competition/{competition_id}/reorder-associated-questions`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderAssociatedQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {ReplaceCompetitionQuestionBody} replaceCompetitionQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiReplaceCompetitionQuestionV2: async (competitionId: string, replaceCompetitionQuestionBody: ReplaceCompetitionQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiReplaceCompetitionQuestionV2', 'competitionId', competitionId)
            // verify required parameter 'replaceCompetitionQuestionBody' is not null or undefined
            assertParamExists('competitionApiReplaceCompetitionQuestionV2', 'replaceCompetitionQuestionBody', replaceCompetitionQuestionBody)
            const localVarPath = `/competition/{competition_id}/replace-question`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceCompetitionQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiResetCompetitionPublicContent: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiResetCompetitionPublicContent', 'competitionId', competitionId)
            const localVarPath = `/admin/competition/{competition_id}/public-content`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiResyncCompetitionCredits: async (competitionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiResyncCompetitionCredits', 'competitionId', competitionId)
            const localVarPath = `/admin/competition/{competition_id}/resync-credits`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {AdminUpdateRegistrationDetails} adminUpdateRegistrationDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiReviewCompetitionEntries: async (competitionId: string, adminUpdateRegistrationDetails: AdminUpdateRegistrationDetails, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiReviewCompetitionEntries', 'competitionId', competitionId)
            // verify required parameter 'adminUpdateRegistrationDetails' is not null or undefined
            assertParamExists('competitionApiReviewCompetitionEntries', 'adminUpdateRegistrationDetails', adminUpdateRegistrationDetails)
            const localVarPath = `/admin/competition/{competition_id}/review-entries`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateRegistrationDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} entryId 
         * @param {ScoreSubmissionBody} scoreSubmissionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiScoreShowcaseEntry: async (competitionId: string, entryId: string, scoreSubmissionBody: ScoreSubmissionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiScoreShowcaseEntry', 'competitionId', competitionId)
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('competitionApiScoreShowcaseEntry', 'entryId', entryId)
            // verify required parameter 'scoreSubmissionBody' is not null or undefined
            assertParamExists('competitionApiScoreShowcaseEntry', 'scoreSubmissionBody', scoreSubmissionBody)
            const localVarPath = `/admin/competition/{competition_id}/submission/{entry_id}/score`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{entry_id}', encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scoreSubmissionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiSendCertificate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/competition/send-certificate-mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {SetCalibrationSkillsBody} setCalibrationSkillsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiSetCalibrationSkills: async (competitionId: string, setCalibrationSkillsBody: SetCalibrationSkillsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiSetCalibrationSkills', 'competitionId', competitionId)
            // verify required parameter 'setCalibrationSkillsBody' is not null or undefined
            assertParamExists('competitionApiSetCalibrationSkills', 'setCalibrationSkillsBody', setCalibrationSkillsBody)
            const localVarPath = `/competition/{competition_id}/calibration/skills`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCalibrationSkillsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {CompetitionPublicListingBody} competitionPublicListingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiSetCompetitionPublicListing: async (competitionId: string, competitionPublicListingBody: CompetitionPublicListingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiSetCompetitionPublicListing', 'competitionId', competitionId)
            // verify required parameter 'competitionPublicListingBody' is not null or undefined
            assertParamExists('competitionApiSetCompetitionPublicListing', 'competitionPublicListingBody', competitionPublicListingBody)
            const localVarPath = `/admin/competition/{competition_id}/public-listing`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(competitionPublicListingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {StartCalibrationBody} startCalibrationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiStartCalibrationSession: async (competitionId: string, startCalibrationBody: StartCalibrationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiStartCalibrationSession', 'competitionId', competitionId)
            // verify required parameter 'startCalibrationBody' is not null or undefined
            assertParamExists('competitionApiStartCalibrationSession', 'startCalibrationBody', startCalibrationBody)
            const localVarPath = `/competition/{competition_id}/calibration/start`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCalibrationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiToggleSubmissionLike: async (competitionId: string, entryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiToggleSubmissionLike', 'competitionId', competitionId)
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('competitionApiToggleSubmissionLike', 'entryId', entryId)
            const localVarPath = `/competition/{competition_id}/submission/{entry_id}/like`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{entry_id}', encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {UnlockCompetitionBody} unlockCompetitionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUnlockCompetition: async (competitionId: string, unlockCompetitionBody: UnlockCompetitionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiUnlockCompetition', 'competitionId', competitionId)
            // verify required parameter 'unlockCompetitionBody' is not null or undefined
            assertParamExists('competitionApiUnlockCompetition', 'unlockCompetitionBody', unlockCompetitionBody)
            const localVarPath = `/competition/{competition_id}/unlock`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unlockCompetitionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} faqId 
         * @param {UpsertCompetitionFAQBody} upsertCompetitionFAQBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpdateCompetitionFaq: async (competitionId: string, faqId: string, upsertCompetitionFAQBody: UpsertCompetitionFAQBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiUpdateCompetitionFaq', 'competitionId', competitionId)
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('competitionApiUpdateCompetitionFaq', 'faqId', faqId)
            // verify required parameter 'upsertCompetitionFAQBody' is not null or undefined
            assertParamExists('competitionApiUpdateCompetitionFaq', 'upsertCompetitionFAQBody', upsertCompetitionFAQBody)
            const localVarPath = `/admin/competition/{competition_id}/faq/{faq_id}`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{faq_id}', encodeURIComponent(String(faqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertCompetitionFAQBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {UpsertSubmissionTemplateBody} upsertSubmissionTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpdateSubmissionTemplate: async (templateId: string, upsertSubmissionTemplateBody: UpsertSubmissionTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('competitionApiUpdateSubmissionTemplate', 'templateId', templateId)
            // verify required parameter 'upsertSubmissionTemplateBody' is not null or undefined
            assertParamExists('competitionApiUpdateSubmissionTemplate', 'upsertSubmissionTemplateBody', upsertSubmissionTemplateBody)
            const localVarPath = `/competition-submission-template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertSubmissionTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [competitionImageFile] 
         * @param {File} [competitionHeaderFile] 
         * @param {File} [mobileHeaderFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUploadCompetitionImages: async (competitionImageFile?: File, competitionHeaderFile?: File, mobileHeaderFile?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/competition/upload-img`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (competitionImageFile !== undefined) { 
                localVarFormParams.append('competition_image_file', competitionImageFile as any);
            }

            if (competitionHeaderFile !== undefined) { 
                localVarFormParams.append('competition_header_file', competitionHeaderFile as any);
            }

            if (mobileHeaderFile !== undefined) { 
                localVarFormParams.append('mobile_header_file', mobileHeaderFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertCompetitionBody} upsertCompetitionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpsertCompetition: async (upsertCompetitionBody: UpsertCompetitionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertCompetitionBody' is not null or undefined
            assertParamExists('competitionApiUpsertCompetition', 'upsertCompetitionBody', upsertCompetitionBody)
            const localVarPath = `/competition-new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertCompetitionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {UpsertCompetitionContentBody} upsertCompetitionContentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpsertCompetitionContent: async (competitionId: string, upsertCompetitionContentBody: UpsertCompetitionContentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiUpsertCompetitionContent', 'competitionId', competitionId)
            // verify required parameter 'upsertCompetitionContentBody' is not null or undefined
            assertParamExists('competitionApiUpsertCompetitionContent', 'upsertCompetitionContentBody', upsertCompetitionContentBody)
            const localVarPath = `/admin/competition/{competition_id}/content`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertCompetitionContentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {UpsertScheduleBody} upsertScheduleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpsertCompetitionSchedule: async (competitionId: string, upsertScheduleBody: UpsertScheduleBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiUpsertCompetitionSchedule', 'competitionId', competitionId)
            // verify required parameter 'upsertScheduleBody' is not null or undefined
            assertParamExists('competitionApiUpsertCompetitionSchedule', 'upsertScheduleBody', upsertScheduleBody)
            const localVarPath = `/competition/{competition_id}/schedule`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertScheduleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {EventPreferencesBody} eventPreferencesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpsertEventPreferences: async (competitionId: string, eventPreferencesBody: EventPreferencesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('competitionApiUpsertEventPreferences', 'competitionId', competitionId)
            // verify required parameter 'eventPreferencesBody' is not null or undefined
            assertParamExists('competitionApiUpsertEventPreferences', 'eventPreferencesBody', eventPreferencesBody)
            const localVarPath = `/competition/{competition_id}/preferences`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventPreferencesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompetitionApiApi - functional programming interface
 */
export const CompetitionApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompetitionApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} competitionId 
         * @param {AddCompetitionQuestionsBody} addCompetitionQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiAddAdminCompetitionQuestions(competitionId: string, addCompetitionQuestionsBody: AddCompetitionQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCompetitionQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiAddAdminCompetitionQuestions(competitionId, addCompetitionQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiAddAdminCompetitionQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {AddCompetitionQuestionsBody} addCompetitionQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiAddCompetitionQuestions(competitionId: string, addCompetitionQuestionsBody: AddCompetitionQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCompetitionQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiAddCompetitionQuestions(competitionId, addCompetitionQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiAddCompetitionQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiAdminCompetitionCleanupScript(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiAdminCompetitionCleanupScript(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiAdminCompetitionCleanupScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AIEnhanceCompetitionDetailsBody} aIEnhanceCompetitionDetailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiAiEnhanceCompetitionDetails(aIEnhanceCompetitionDetailsBody: AIEnhanceCompetitionDetailsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiAiEnhanceCompetitionDetails(aIEnhanceCompetitionDetailsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiAiEnhanceCompetitionDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {ReorderAssociatedQuestionsBody} reorderAssociatedQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiAssociateManualQuestions(competitionId: string, reorderAssociatedQuestionsBody: ReorderAssociatedQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiAssociateManualQuestions(competitionId, reorderAssociatedQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiAssociateManualQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiBanCompetitionUser(competitionId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BanCompetitionUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiBanCompetitionUser(competitionId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiBanCompetitionUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {CompetitionRegistrationBody} competitionRegistrationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiCompetitionRegistrations(competitionId: string, competitionRegistrationBody: CompetitionRegistrationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiCompetitionRegistrations(competitionId, competitionRegistrationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiCompetitionRegistrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string | null} [title] 
         * @param {string | null} [description] 
         * @param {string | null} [projectUrl] 
         * @param {File | null} [projectFile] 
         * @param {string | null} [submissionData] 
         * @param {string | null} [sessionId] 
         * @param {string | null} [entryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiCompetitionRegistrationsEntrySubmit(competitionId: string, title?: string | null, description?: string | null, projectUrl?: string | null, projectFile?: File | null, submissionData?: string | null, sessionId?: string | null, entryId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiCompetitionRegistrationsEntrySubmit(competitionId, title, description, projectUrl, projectFile, submissionData, sessionId, entryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiCompetitionRegistrationsEntrySubmit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {UpsertCompetitionFAQBody} upsertCompetitionFAQBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiCreateCompetitionFaq(competitionId: string, upsertCompetitionFAQBody: UpsertCompetitionFAQBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionFAQItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiCreateCompetitionFaq(competitionId, upsertCompetitionFAQBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiCreateCompetitionFaq']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GenerateCompetitionProfileMatchBody} generateCompetitionProfileMatchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiCreateCompetitionMatch(generateCompetitionProfileMatchBody: GenerateCompetitionProfileMatchBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiCreateCompetitionMatch(generateCompetitionProfileMatchBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiCreateCompetitionMatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertSubmissionTemplateBody} upsertSubmissionTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiCreateSubmissionTemplate(upsertSubmissionTemplateBody: UpsertSubmissionTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiCreateSubmissionTemplate(upsertSubmissionTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiCreateSubmissionTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {DeleteAssociatedQuestionsBody} deleteAssociatedQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiDeleteAssociatedQuestions(competitionId: string, deleteAssociatedQuestionsBody: DeleteAssociatedQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiDeleteAssociatedQuestions(competitionId, deleteAssociatedQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiDeleteAssociatedQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiDeleteCompetition(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiDeleteCompetition(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiDeleteCompetition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} faqId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiDeleteCompetitionFaq(competitionId: string, faqId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiDeleteCompetitionFaq(competitionId, faqId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiDeleteCompetitionFaq']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} scheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiDeleteCompetitionSchedule(scheduleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteCompetitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiDeleteCompetitionSchedule(scheduleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiDeleteCompetitionSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiDeleteSubmissionTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiDeleteSubmissionTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiDeleteSubmissionTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGenerateCertificate(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateCertificateResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGenerateCertificate(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGenerateCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {GenerateCompetitionQuestionsV2Body} generateCompetitionQuestionsV2Body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGenerateCompetitionQuestionsV2(competitionId: string, generateCompetitionQuestionsV2Body: GenerateCompetitionQuestionsV2Body, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGenerateCompetitionQuestionsV2(competitionId, generateCompetitionQuestionsV2Body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGenerateCompetitionQuestionsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetAdminCompetitionQuestions(competitionId: string, pageNo?: number, pageSize?: number, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompetitionQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetAdminCompetitionQuestions(competitionId, pageNo, pageSize, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetAdminCompetitionQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean | null} [isRegistered] 
         * @param {CompetitionApiGetAllCompetitionsLifecycleEnum} [lifecycle] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {string} [status] 
         * @param {CompetitionApiGetAllCompetitionsTypeOfCompetitionEnum} [typeOfCompetition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetAllCompetitions(isRegistered?: boolean | null, lifecycle?: CompetitionApiGetAllCompetitionsLifecycleEnum, page?: string, pageSize?: string, searchQuery?: string, status?: string, typeOfCompetition?: CompetitionApiGetAllCompetitionsTypeOfCompetitionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompetitionListCardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetAllCompetitions(isRegistered, lifecycle, page, pageSize, searchQuery, status, typeOfCompetition, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetAllCompetitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCalibrationStatus(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCalibrationStatus(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCalibrationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} certificateAlias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCertificateDetailsByAlias(certificateAlias: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateDetailsByAliasResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCertificateDetailsByAlias(certificateAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCertificateDetailsByAlias']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompactCompetitionAnalyticsByUser(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionAnalyticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompactCompetitionAnalyticsByUser(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompactCompetitionAnalyticsByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompetitionById(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllCompetitionsSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompetitionById(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompetitionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompetitionContent(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionContentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompetitionContent(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompetitionContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompetitionContentBrief(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionContentBriefResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompetitionContentBrief(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompetitionContentBrief']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompetitionLeaderboard(competitionId: string, page?: number, pageSize?: number, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompetitionsRegistrations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompetitionLeaderboard(competitionId, page, pageSize, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompetitionLeaderboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [name] 
         * @param {string} [ongoing] 
         * @param {string} [pageNo] 
         * @param {string} [pageSize] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompetitionList(endDate?: string, name?: string, ongoing?: string, pageNo?: string, pageSize?: string, startDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompetitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompetitionList(endDate, name, ongoing, pageNo, pageSize, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompetitionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompetitionPublishReadiness(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionPublishReadinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompetitionPublishReadiness(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompetitionPublishReadiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [searchQuery] 
         * @param {string | null} [sortBy] 
         * @param {string | null} [sortOrder] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompetitionRegistrations(competitionId: string, page?: number, pageSize?: number, searchQuery?: string | null, sortBy?: string | null, sortOrder?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompetitionsRegistrations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompetitionRegistrations(competitionId, page, pageSize, searchQuery, sortBy, sortOrder, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompetitionRegistrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [competitionId] 
         * @param {string} [competitionScheduleId] 
         * @param {string} [isActive] 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompetitionSchedules(competitionId?: string, competitionScheduleId?: string, isActive?: string, pageNo?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompetitionSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompetitionSchedules(competitionId, competitionScheduleId, isActive, pageNo, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompetitionSchedules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompetitionStartStatistics(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionStartStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompetitionStartStatistics(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompetitionStartStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompetitionSubmissions(competitionId: string, page?: number, pageSize?: number, sortBy?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GallerySubmissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompetitionSubmissions(competitionId, page, pageSize, sortBy, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompetitionSubmissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [competitionId] 
         * @param {string} [examId] 
         * @param {string} [filterType] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchString] 
         * @param {Array<string>} [skillIds] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetCompetitionUserAnsweredQuestionsAnalytics(competitionId?: string, examId?: string, filterType?: string, page?: number, pageSize?: number, searchString?: string, skillIds?: Array<string>, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnsweredQuestionsAndAnalyticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetCompetitionUserAnsweredQuestionsAnalytics(competitionId, examId, filterType, page, pageSize, searchString, skillIds, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetCompetitionUserAnsweredQuestionsAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetDetailedCompetitionAnalyticsByUser(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedCompetitionAnalyticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetDetailedCompetitionAnalyticsByUser(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetDetailedCompetitionAnalyticsByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetInvites(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompetitionInvitesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetInvites(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetMySubmissions(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MySubmissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetMySubmissions(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetMySubmissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean | null} [isRegistered] 
         * @param {CompetitionApiGetPrivateAllCompetitionsLifecycleEnum} [lifecycle] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [searchQuery] 
         * @param {string} [status] 
         * @param {CompetitionApiGetPrivateAllCompetitionsTypeOfCompetitionEnum} [typeOfCompetition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetPrivateAllCompetitions(isRegistered?: boolean | null, lifecycle?: CompetitionApiGetPrivateAllCompetitionsLifecycleEnum, page?: string, pageSize?: string, searchQuery?: string, status?: string, typeOfCompetition?: CompetitionApiGetPrivateAllCompetitionsTypeOfCompetitionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompetitionListCardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetPrivateAllCompetitions(isRegistered, lifecycle, page, pageSize, searchQuery, status, typeOfCompetition, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetPrivateAllCompetitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetPublicCompetitionLeaderboard(competitionId: string, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicLeaderboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetPublicCompetitionLeaderboard(competitionId, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetPublicCompetitionLeaderboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [sortBy] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetPublicCompetitionSubmissions(competitionId: string, page?: number, pageSize?: number, sortBy?: string | null, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GallerySubmissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetPublicCompetitionSubmissions(competitionId, page, pageSize, sortBy, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetPublicCompetitionSubmissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetPublicSingleSubmission(competitionId: string, entryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetPublicSingleSubmission(competitionId, entryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetPublicSingleSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetSingleSubmission(competitionId: string, entryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetSingleSubmission(competitionId, entryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetSingleSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetSubmissionTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetSubmissionTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetSubmissionTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [includeArchived] 
         * @param {string | null} [orgId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetSubmissionTemplates(includeArchived?: boolean, orgId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionTemplateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetSubmissionTemplates(includeArchived, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetSubmissionTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetUserCompetitionAchievements(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCompetitionAchievementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetUserCompetitionAchievements(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetUserCompetitionAchievements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {number} [pageNo] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiGetUserReferralByCompetition(competitionId: string, pageNo?: number, pageSize?: number, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserReferralsByCompetitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiGetUserReferralByCompetition(competitionId, pageNo, pageSize, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiGetUserReferralByCompetition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {CompetitionInvitationBody} competitionInvitationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiInviteUsersCompetition(competitionId: string, competitionInvitationBody: CompetitionInvitationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionInvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiInviteUsersCompetition(competitionId, competitionInvitationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiInviteUsersCompetition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} alias 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiIsCompetitionAliasAvailable(alias: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsAliasAvailableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiIsCompetitionAliasAvailable(alias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiIsCompetitionAliasAvailable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiListCompetitionFaqs(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompetitionFAQListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiListCompetitionFaqs(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiListCompetitionFaqs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiLockCompetition(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiLockCompetition(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiLockCompetition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiPublicGetCompetitionById(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllCompetitionsSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiPublicGetCompetitionById(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiPublicGetCompetitionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiRedeemCompetitionPremiumProfile(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedeemCompetitionPremiumProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiRedeemCompetitionPremiumProfile(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiRedeemCompetitionPremiumProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiRegenerateCompetitionInvites(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiRegenerateCompetitionInvites(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiRegenerateCompetitionInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {ReorderAssociatedQuestionsBody} reorderAssociatedQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiReorderCompetitionQuestionsMapping(competitionId: string, reorderAssociatedQuestionsBody: ReorderAssociatedQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiReorderCompetitionQuestionsMapping(competitionId, reorderAssociatedQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiReorderCompetitionQuestionsMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {ReplaceCompetitionQuestionBody} replaceCompetitionQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiReplaceCompetitionQuestionV2(competitionId: string, replaceCompetitionQuestionBody: ReplaceCompetitionQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiReplaceCompetitionQuestionV2(competitionId, replaceCompetitionQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiReplaceCompetitionQuestionV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiResetCompetitionPublicContent(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiResetCompetitionPublicContent(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiResetCompetitionPublicContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiResyncCompetitionCredits(competitionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMsg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiResyncCompetitionCredits(competitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiResyncCompetitionCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {AdminUpdateRegistrationDetails} adminUpdateRegistrationDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiReviewCompetitionEntries(competitionId: string, adminUpdateRegistrationDetails: AdminUpdateRegistrationDetails, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiReviewCompetitionEntries(competitionId, adminUpdateRegistrationDetails, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiReviewCompetitionEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} entryId 
         * @param {ScoreSubmissionBody} scoreSubmissionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiScoreShowcaseEntry(competitionId: string, entryId: string, scoreSubmissionBody: ScoreSubmissionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoreSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiScoreShowcaseEntry(competitionId, entryId, scoreSubmissionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiScoreShowcaseEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiSendCertificate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendCertificateBody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiSendCertificate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiSendCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {SetCalibrationSkillsBody} setCalibrationSkillsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiSetCalibrationSkills(competitionId: string, setCalibrationSkillsBody: SetCalibrationSkillsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetCalibrationSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiSetCalibrationSkills(competitionId, setCalibrationSkillsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiSetCalibrationSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {CompetitionPublicListingBody} competitionPublicListingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiSetCompetitionPublicListing(competitionId: string, competitionPublicListingBody: CompetitionPublicListingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionContentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiSetCompetitionPublicListing(competitionId, competitionPublicListingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiSetCompetitionPublicListing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {StartCalibrationBody} startCalibrationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiStartCalibrationSession(competitionId: string, startCalibrationBody: StartCalibrationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartCalibrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiStartCalibrationSession(competitionId, startCalibrationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiStartCalibrationSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiToggleSubmissionLike(competitionId: string, entryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionLikeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiToggleSubmissionLike(competitionId, entryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiToggleSubmissionLike']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {UnlockCompetitionBody} unlockCompetitionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiUnlockCompetition(competitionId: string, unlockCompetitionBody: UnlockCompetitionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiUnlockCompetition(competitionId, unlockCompetitionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiUnlockCompetition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} faqId 
         * @param {UpsertCompetitionFAQBody} upsertCompetitionFAQBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiUpdateCompetitionFaq(competitionId: string, faqId: string, upsertCompetitionFAQBody: UpsertCompetitionFAQBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionFAQItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiUpdateCompetitionFaq(competitionId, faqId, upsertCompetitionFAQBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiUpdateCompetitionFaq']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {UpsertSubmissionTemplateBody} upsertSubmissionTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiUpdateSubmissionTemplate(templateId: string, upsertSubmissionTemplateBody: UpsertSubmissionTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiUpdateSubmissionTemplate(templateId, upsertSubmissionTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiUpdateSubmissionTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [competitionImageFile] 
         * @param {File} [competitionHeaderFile] 
         * @param {File} [mobileHeaderFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiUploadCompetitionImages(competitionImageFile?: File, competitionHeaderFile?: File, mobileHeaderFile?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionImageUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiUploadCompetitionImages(competitionImageFile, competitionHeaderFile, mobileHeaderFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiUploadCompetitionImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertCompetitionBody} upsertCompetitionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiUpsertCompetition(upsertCompetitionBody: UpsertCompetitionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllCompetitionsSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiUpsertCompetition(upsertCompetitionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiUpsertCompetition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {UpsertCompetitionContentBody} upsertCompetitionContentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiUpsertCompetitionContent(competitionId: string, upsertCompetitionContentBody: UpsertCompetitionContentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompetitionContentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiUpsertCompetitionContent(competitionId, upsertCompetitionContentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiUpsertCompetitionContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {UpsertScheduleBody} upsertScheduleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiUpsertCompetitionSchedule(competitionId: string, upsertScheduleBody: UpsertScheduleBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiUpsertCompetitionSchedule(competitionId, upsertScheduleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiUpsertCompetitionSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {EventPreferencesBody} eventPreferencesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async competitionApiUpsertEventPreferences(competitionId: string, eventPreferencesBody: EventPreferencesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.competitionApiUpsertEventPreferences(competitionId, eventPreferencesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompetitionApiApi.competitionApiUpsertEventPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompetitionApiApi - factory interface
 */
export const CompetitionApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompetitionApiApiFp(configuration)
    return {
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiAddAdminCompetitionQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiAddAdminCompetitionQuestions(requestParameters: CompetitionApiApiCompetitionApiAddAdminCompetitionQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddCompetitionQuestionsResponse> {
            return localVarFp.competitionApiAddAdminCompetitionQuestions(requestParameters.competitionId, requestParameters.addCompetitionQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiAddCompetitionQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiAddCompetitionQuestions(requestParameters: CompetitionApiApiCompetitionApiAddCompetitionQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddCompetitionQuestionsResponse> {
            return localVarFp.competitionApiAddCompetitionQuestions(requestParameters.competitionId, requestParameters.addCompetitionQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiAdminCompetitionCleanupScript(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiAdminCompetitionCleanupScript(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiAiEnhanceCompetitionDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiAiEnhanceCompetitionDetails(requestParameters: CompetitionApiApiCompetitionApiAiEnhanceCompetitionDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiAiEnhanceCompetitionDetails(requestParameters.aIEnhanceCompetitionDetailsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiAssociateManualQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiAssociateManualQuestions(requestParameters: CompetitionApiApiCompetitionApiAssociateManualQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiAssociateManualQuestions(requestParameters.competitionId, requestParameters.reorderAssociatedQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiBanCompetitionUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiBanCompetitionUser(requestParameters: CompetitionApiApiCompetitionApiBanCompetitionUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<BanCompetitionUserResponse> {
            return localVarFp.competitionApiBanCompetitionUser(requestParameters.competitionId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiCompetitionRegistrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiCompetitionRegistrations(requestParameters: CompetitionApiApiCompetitionApiCompetitionRegistrationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiCompetitionRegistrations(requestParameters.competitionId, requestParameters.competitionRegistrationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiCompetitionRegistrationsEntrySubmitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiCompetitionRegistrationsEntrySubmit(requestParameters: CompetitionApiApiCompetitionApiCompetitionRegistrationsEntrySubmitRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiCompetitionRegistrationsEntrySubmit(requestParameters.competitionId, requestParameters.title, requestParameters.description, requestParameters.projectUrl, requestParameters.projectFile, requestParameters.submissionData, requestParameters.sessionId, requestParameters.entryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiCreateCompetitionFaqRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiCreateCompetitionFaq(requestParameters: CompetitionApiApiCompetitionApiCreateCompetitionFaqRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionFAQItem> {
            return localVarFp.competitionApiCreateCompetitionFaq(requestParameters.competitionId, requestParameters.upsertCompetitionFAQBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiCreateCompetitionMatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiCreateCompetitionMatch(requestParameters: CompetitionApiApiCompetitionApiCreateCompetitionMatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiCreateCompetitionMatch(requestParameters.generateCompetitionProfileMatchBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiCreateSubmissionTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiCreateSubmissionTemplate(requestParameters: CompetitionApiApiCompetitionApiCreateSubmissionTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionTemplate> {
            return localVarFp.competitionApiCreateSubmissionTemplate(requestParameters.upsertSubmissionTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiDeleteAssociatedQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiDeleteAssociatedQuestions(requestParameters: CompetitionApiApiCompetitionApiDeleteAssociatedQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiDeleteAssociatedQuestions(requestParameters.competitionId, requestParameters.deleteAssociatedQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiDeleteCompetitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiDeleteCompetition(requestParameters: CompetitionApiApiCompetitionApiDeleteCompetitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiDeleteCompetition(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiDeleteCompetitionFaqRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiDeleteCompetitionFaq(requestParameters: CompetitionApiApiCompetitionApiDeleteCompetitionFaqRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiDeleteCompetitionFaq(requestParameters.competitionId, requestParameters.faqId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiDeleteCompetitionScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiDeleteCompetitionSchedule(requestParameters: CompetitionApiApiCompetitionApiDeleteCompetitionScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteCompetitionResponse> {
            return localVarFp.competitionApiDeleteCompetitionSchedule(requestParameters.scheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiDeleteSubmissionTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiDeleteSubmissionTemplate(requestParameters: CompetitionApiApiCompetitionApiDeleteSubmissionTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiDeleteSubmissionTemplate(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGenerateCertificateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGenerateCertificate(requestParameters: CompetitionApiApiCompetitionApiGenerateCertificateRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateCertificateResponseBase> {
            return localVarFp.competitionApiGenerateCertificate(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGenerateCompetitionQuestionsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGenerateCompetitionQuestionsV2(requestParameters: CompetitionApiApiCompetitionApiGenerateCompetitionQuestionsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiGenerateCompetitionQuestionsV2(requestParameters.competitionId, requestParameters.generateCompetitionQuestionsV2Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetAdminCompetitionQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetAdminCompetitionQuestions(requestParameters: CompetitionApiApiCompetitionApiGetAdminCompetitionQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCompetitionQuestionsResponse> {
            return localVarFp.competitionApiGetAdminCompetitionQuestions(requestParameters.competitionId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetAllCompetitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetAllCompetitions(requestParameters: CompetitionApiApiCompetitionApiGetAllCompetitionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCompetitionListCardResponse> {
            return localVarFp.competitionApiGetAllCompetitions(requestParameters.isRegistered, requestParameters.lifecycle, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.status, requestParameters.typeOfCompetition, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCalibrationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCalibrationStatus(requestParameters: CompetitionApiApiCompetitionApiGetCalibrationStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<CalibrationStatusResponse> {
            return localVarFp.competitionApiGetCalibrationStatus(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCertificateDetailsByAliasRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCertificateDetailsByAlias(requestParameters: CompetitionApiApiCompetitionApiGetCertificateDetailsByAliasRequest, options?: RawAxiosRequestConfig): AxiosPromise<CertificateDetailsByAliasResponse> {
            return localVarFp.competitionApiGetCertificateDetailsByAlias(requestParameters.certificateAlias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompactCompetitionAnalyticsByUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompactCompetitionAnalyticsByUser(requestParameters: CompetitionApiApiCompetitionApiGetCompactCompetitionAnalyticsByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionAnalyticsResponse> {
            return localVarFp.competitionApiGetCompactCompetitionAnalyticsByUser(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompetitionByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionById(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAllCompetitionsSub> {
            return localVarFp.competitionApiGetCompetitionById(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompetitionContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionContent(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionContentResponse> {
            return localVarFp.competitionApiGetCompetitionContent(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompetitionContentBriefRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionContentBrief(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionContentBriefRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionContentBriefResponse> {
            return localVarFp.competitionApiGetCompetitionContentBrief(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompetitionLeaderboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionLeaderboard(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionLeaderboardRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCompetitionsRegistrations> {
            return localVarFp.competitionApiGetCompetitionLeaderboard(requestParameters.competitionId, requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompetitionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionList(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCompetitionResponse> {
            return localVarFp.competitionApiGetCompetitionList(requestParameters.endDate, requestParameters.name, requestParameters.ongoing, requestParameters.pageNo, requestParameters.pageSize, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompetitionPublishReadinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionPublishReadiness(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionPublishReadinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionPublishReadinessResponse> {
            return localVarFp.competitionApiGetCompetitionPublishReadiness(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompetitionRegistrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionRegistrations(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionRegistrationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCompetitionsRegistrations> {
            return localVarFp.competitionApiGetCompetitionRegistrations(requestParameters.competitionId, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompetitionSchedulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionSchedules(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionSchedulesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCompetitionSchedulesResponse> {
            return localVarFp.competitionApiGetCompetitionSchedules(requestParameters.competitionId, requestParameters.competitionScheduleId, requestParameters.isActive, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompetitionStartStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionStartStatistics(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionStartStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionStartStatisticsResponse> {
            return localVarFp.competitionApiGetCompetitionStartStatistics(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompetitionSubmissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionSubmissions(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionSubmissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GallerySubmissionsResponse> {
            return localVarFp.competitionApiGetCompetitionSubmissions(requestParameters.competitionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetCompetitionUserAnsweredQuestionsAnalyticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetCompetitionUserAnsweredQuestionsAnalytics(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionUserAnsweredQuestionsAnalyticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AnsweredQuestionsAndAnalyticsResponse> {
            return localVarFp.competitionApiGetCompetitionUserAnsweredQuestionsAnalytics(requestParameters.competitionId, requestParameters.examId, requestParameters.filterType, requestParameters.page, requestParameters.pageSize, requestParameters.searchString, requestParameters.skillIds, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetDetailedCompetitionAnalyticsByUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetDetailedCompetitionAnalyticsByUser(requestParameters: CompetitionApiApiCompetitionApiGetDetailedCompetitionAnalyticsByUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<DetailedCompetitionAnalyticsResponse> {
            return localVarFp.competitionApiGetDetailedCompetitionAnalyticsByUser(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetInvites(requestParameters: CompetitionApiApiCompetitionApiGetInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCompetitionInvitesResponse> {
            return localVarFp.competitionApiGetInvites(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetMySubmissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetMySubmissions(requestParameters: CompetitionApiApiCompetitionApiGetMySubmissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MySubmissionsResponse> {
            return localVarFp.competitionApiGetMySubmissions(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetPrivateAllCompetitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetPrivateAllCompetitions(requestParameters: CompetitionApiApiCompetitionApiGetPrivateAllCompetitionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCompetitionListCardResponse> {
            return localVarFp.competitionApiGetPrivateAllCompetitions(requestParameters.isRegistered, requestParameters.lifecycle, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.status, requestParameters.typeOfCompetition, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetPublicCompetitionLeaderboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetPublicCompetitionLeaderboard(requestParameters: CompetitionApiApiCompetitionApiGetPublicCompetitionLeaderboardRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicLeaderboardResponse> {
            return localVarFp.competitionApiGetPublicCompetitionLeaderboard(requestParameters.competitionId, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetPublicCompetitionSubmissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetPublicCompetitionSubmissions(requestParameters: CompetitionApiApiCompetitionApiGetPublicCompetitionSubmissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GallerySubmissionsResponse> {
            return localVarFp.competitionApiGetPublicCompetitionSubmissions(requestParameters.competitionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetPublicSingleSubmissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetPublicSingleSubmission(requestParameters: CompetitionApiApiCompetitionApiGetPublicSingleSubmissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleSubmissionResponse> {
            return localVarFp.competitionApiGetPublicSingleSubmission(requestParameters.competitionId, requestParameters.entryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetSingleSubmissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetSingleSubmission(requestParameters: CompetitionApiApiCompetitionApiGetSingleSubmissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleSubmissionResponse> {
            return localVarFp.competitionApiGetSingleSubmission(requestParameters.competitionId, requestParameters.entryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetSubmissionTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetSubmissionTemplate(requestParameters: CompetitionApiApiCompetitionApiGetSubmissionTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionTemplate> {
            return localVarFp.competitionApiGetSubmissionTemplate(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetSubmissionTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetSubmissionTemplates(requestParameters: CompetitionApiApiCompetitionApiGetSubmissionTemplatesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionTemplateListResponse> {
            return localVarFp.competitionApiGetSubmissionTemplates(requestParameters.includeArchived, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetUserCompetitionAchievementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetUserCompetitionAchievements(requestParameters: CompetitionApiApiCompetitionApiGetUserCompetitionAchievementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserCompetitionAchievementsResponse> {
            return localVarFp.competitionApiGetUserCompetitionAchievements(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiGetUserReferralByCompetitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiGetUserReferralByCompetition(requestParameters: CompetitionApiApiCompetitionApiGetUserReferralByCompetitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserReferralsByCompetitionResponse> {
            return localVarFp.competitionApiGetUserReferralByCompetition(requestParameters.competitionId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiInviteUsersCompetitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiInviteUsersCompetition(requestParameters: CompetitionApiApiCompetitionApiInviteUsersCompetitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionInvitationResponse> {
            return localVarFp.competitionApiInviteUsersCompetition(requestParameters.competitionId, requestParameters.competitionInvitationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiIsCompetitionAliasAvailableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiIsCompetitionAliasAvailable(requestParameters: CompetitionApiApiCompetitionApiIsCompetitionAliasAvailableRequest, options?: RawAxiosRequestConfig): AxiosPromise<IsAliasAvailableResponse> {
            return localVarFp.competitionApiIsCompetitionAliasAvailable(requestParameters.alias, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiListCompetitionFaqsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiListCompetitionFaqs(requestParameters: CompetitionApiApiCompetitionApiListCompetitionFaqsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCompetitionFAQListResponse> {
            return localVarFp.competitionApiListCompetitionFaqs(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiLockCompetitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiLockCompetition(requestParameters: CompetitionApiApiCompetitionApiLockCompetitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiLockCompetition(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiPublicGetCompetitionByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiPublicGetCompetitionById(requestParameters: CompetitionApiApiCompetitionApiPublicGetCompetitionByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAllCompetitionsSub> {
            return localVarFp.competitionApiPublicGetCompetitionById(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiRedeemCompetitionPremiumProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiRedeemCompetitionPremiumProfile(requestParameters: CompetitionApiApiCompetitionApiRedeemCompetitionPremiumProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<RedeemCompetitionPremiumProfileResponse> {
            return localVarFp.competitionApiRedeemCompetitionPremiumProfile(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiRegenerateCompetitionInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiRegenerateCompetitionInvites(requestParameters: CompetitionApiApiCompetitionApiRegenerateCompetitionInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiRegenerateCompetitionInvites(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiReorderCompetitionQuestionsMappingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiReorderCompetitionQuestionsMapping(requestParameters: CompetitionApiApiCompetitionApiReorderCompetitionQuestionsMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiReorderCompetitionQuestionsMapping(requestParameters.competitionId, requestParameters.reorderAssociatedQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiReplaceCompetitionQuestionV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiReplaceCompetitionQuestionV2(requestParameters: CompetitionApiApiCompetitionApiReplaceCompetitionQuestionV2Request, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiReplaceCompetitionQuestionV2(requestParameters.competitionId, requestParameters.replaceCompetitionQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiResetCompetitionPublicContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiResetCompetitionPublicContent(requestParameters: CompetitionApiApiCompetitionApiResetCompetitionPublicContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiResetCompetitionPublicContent(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiResyncCompetitionCreditsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiResyncCompetitionCredits(requestParameters: CompetitionApiApiCompetitionApiResyncCompetitionCreditsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMsg> {
            return localVarFp.competitionApiResyncCompetitionCredits(requestParameters.competitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiReviewCompetitionEntriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiReviewCompetitionEntries(requestParameters: CompetitionApiApiCompetitionApiReviewCompetitionEntriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiReviewCompetitionEntries(requestParameters.competitionId, requestParameters.adminUpdateRegistrationDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiScoreShowcaseEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiScoreShowcaseEntry(requestParameters: CompetitionApiApiCompetitionApiScoreShowcaseEntryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScoreSubmissionResponse> {
            return localVarFp.competitionApiScoreShowcaseEntry(requestParameters.competitionId, requestParameters.entryId, requestParameters.scoreSubmissionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiSendCertificate(options?: RawAxiosRequestConfig): AxiosPromise<SendCertificateBody> {
            return localVarFp.competitionApiSendCertificate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiSetCalibrationSkillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiSetCalibrationSkills(requestParameters: CompetitionApiApiCompetitionApiSetCalibrationSkillsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetCalibrationSkillsResponse> {
            return localVarFp.competitionApiSetCalibrationSkills(requestParameters.competitionId, requestParameters.setCalibrationSkillsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiSetCompetitionPublicListingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiSetCompetitionPublicListing(requestParameters: CompetitionApiApiCompetitionApiSetCompetitionPublicListingRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionContentResponse> {
            return localVarFp.competitionApiSetCompetitionPublicListing(requestParameters.competitionId, requestParameters.competitionPublicListingBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiStartCalibrationSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiStartCalibrationSession(requestParameters: CompetitionApiApiCompetitionApiStartCalibrationSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartCalibrationResponse> {
            return localVarFp.competitionApiStartCalibrationSession(requestParameters.competitionId, requestParameters.startCalibrationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiToggleSubmissionLikeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiToggleSubmissionLike(requestParameters: CompetitionApiApiCompetitionApiToggleSubmissionLikeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionLikeResponse> {
            return localVarFp.competitionApiToggleSubmissionLike(requestParameters.competitionId, requestParameters.entryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiUnlockCompetitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUnlockCompetition(requestParameters: CompetitionApiApiCompetitionApiUnlockCompetitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiUnlockCompetition(requestParameters.competitionId, requestParameters.unlockCompetitionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiUpdateCompetitionFaqRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpdateCompetitionFaq(requestParameters: CompetitionApiApiCompetitionApiUpdateCompetitionFaqRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionFAQItem> {
            return localVarFp.competitionApiUpdateCompetitionFaq(requestParameters.competitionId, requestParameters.faqId, requestParameters.upsertCompetitionFAQBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiUpdateSubmissionTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpdateSubmissionTemplate(requestParameters: CompetitionApiApiCompetitionApiUpdateSubmissionTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionTemplate> {
            return localVarFp.competitionApiUpdateSubmissionTemplate(requestParameters.templateId, requestParameters.upsertSubmissionTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiUploadCompetitionImagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUploadCompetitionImages(requestParameters: CompetitionApiApiCompetitionApiUploadCompetitionImagesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionImageUploadResponse> {
            return localVarFp.competitionApiUploadCompetitionImages(requestParameters.competitionImageFile, requestParameters.competitionHeaderFile, requestParameters.mobileHeaderFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiUpsertCompetitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpsertCompetition(requestParameters: CompetitionApiApiCompetitionApiUpsertCompetitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAllCompetitionsSub> {
            return localVarFp.competitionApiUpsertCompetition(requestParameters.upsertCompetitionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiUpsertCompetitionContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpsertCompetitionContent(requestParameters: CompetitionApiApiCompetitionApiUpsertCompetitionContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompetitionContentResponse> {
            return localVarFp.competitionApiUpsertCompetitionContent(requestParameters.competitionId, requestParameters.upsertCompetitionContentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiUpsertCompetitionScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpsertCompetitionSchedule(requestParameters: CompetitionApiApiCompetitionApiUpsertCompetitionScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpsertScheduleResponse> {
            return localVarFp.competitionApiUpsertCompetitionSchedule(requestParameters.competitionId, requestParameters.upsertScheduleBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompetitionApiApiCompetitionApiUpsertEventPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        competitionApiUpsertEventPreferences(requestParameters: CompetitionApiApiCompetitionApiUpsertEventPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.competitionApiUpsertEventPreferences(requestParameters.competitionId, requestParameters.eventPreferencesBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for competitionApiAddAdminCompetitionQuestions operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiAddAdminCompetitionQuestionsRequest {
    readonly competitionId: string

    readonly addCompetitionQuestionsBody: AddCompetitionQuestionsBody
}

/**
 * Request parameters for competitionApiAddCompetitionQuestions operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiAddCompetitionQuestionsRequest {
    readonly competitionId: string

    readonly addCompetitionQuestionsBody: AddCompetitionQuestionsBody
}

/**
 * Request parameters for competitionApiAiEnhanceCompetitionDetails operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiAiEnhanceCompetitionDetailsRequest {
    readonly aIEnhanceCompetitionDetailsBody: AIEnhanceCompetitionDetailsBody
}

/**
 * Request parameters for competitionApiAssociateManualQuestions operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiAssociateManualQuestionsRequest {
    readonly competitionId: string

    readonly reorderAssociatedQuestionsBody: ReorderAssociatedQuestionsBody
}

/**
 * Request parameters for competitionApiBanCompetitionUser operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiBanCompetitionUserRequest {
    readonly competitionId: string

    readonly userId: string
}

/**
 * Request parameters for competitionApiCompetitionRegistrations operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiCompetitionRegistrationsRequest {
    readonly competitionId: string

    readonly competitionRegistrationBody: CompetitionRegistrationBody
}

/**
 * Request parameters for competitionApiCompetitionRegistrationsEntrySubmit operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiCompetitionRegistrationsEntrySubmitRequest {
    readonly competitionId: string

    readonly title?: string | null

    readonly description?: string | null

    readonly projectUrl?: string | null

    readonly projectFile?: File | null

    readonly submissionData?: string | null

    readonly sessionId?: string | null

    readonly entryId?: string | null
}

/**
 * Request parameters for competitionApiCreateCompetitionFaq operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiCreateCompetitionFaqRequest {
    readonly competitionId: string

    readonly upsertCompetitionFAQBody: UpsertCompetitionFAQBody
}

/**
 * Request parameters for competitionApiCreateCompetitionMatch operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiCreateCompetitionMatchRequest {
    readonly generateCompetitionProfileMatchBody: GenerateCompetitionProfileMatchBody
}

/**
 * Request parameters for competitionApiCreateSubmissionTemplate operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiCreateSubmissionTemplateRequest {
    readonly upsertSubmissionTemplateBody: UpsertSubmissionTemplateBody
}

/**
 * Request parameters for competitionApiDeleteAssociatedQuestions operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiDeleteAssociatedQuestionsRequest {
    readonly competitionId: string

    readonly deleteAssociatedQuestionsBody: DeleteAssociatedQuestionsBody
}

/**
 * Request parameters for competitionApiDeleteCompetition operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiDeleteCompetitionRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiDeleteCompetitionFaq operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiDeleteCompetitionFaqRequest {
    readonly competitionId: string

    readonly faqId: string
}

/**
 * Request parameters for competitionApiDeleteCompetitionSchedule operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiDeleteCompetitionScheduleRequest {
    readonly scheduleId: string
}

/**
 * Request parameters for competitionApiDeleteSubmissionTemplate operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiDeleteSubmissionTemplateRequest {
    readonly templateId: string
}

/**
 * Request parameters for competitionApiGenerateCertificate operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGenerateCertificateRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiGenerateCompetitionQuestionsV2 operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGenerateCompetitionQuestionsV2Request {
    readonly competitionId: string

    readonly generateCompetitionQuestionsV2Body: GenerateCompetitionQuestionsV2Body
}

/**
 * Request parameters for competitionApiGetAdminCompetitionQuestions operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetAdminCompetitionQuestionsRequest {
    readonly competitionId: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly totalPages?: number
}

/**
 * Request parameters for competitionApiGetAllCompetitions operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetAllCompetitionsRequest {
    readonly isRegistered?: boolean | null

    readonly lifecycle?: CompetitionApiGetAllCompetitionsLifecycleEnum

    readonly page?: string

    readonly pageSize?: string

    readonly searchQuery?: string

    readonly status?: string

    readonly typeOfCompetition?: CompetitionApiGetAllCompetitionsTypeOfCompetitionEnum
}

/**
 * Request parameters for competitionApiGetCalibrationStatus operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCalibrationStatusRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiGetCertificateDetailsByAlias operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCertificateDetailsByAliasRequest {
    readonly certificateAlias: string
}

/**
 * Request parameters for competitionApiGetCompactCompetitionAnalyticsByUser operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompactCompetitionAnalyticsByUserRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiGetCompetitionById operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompetitionByIdRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiGetCompetitionContent operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompetitionContentRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiGetCompetitionContentBrief operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompetitionContentBriefRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiGetCompetitionLeaderboard operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompetitionLeaderboardRequest {
    readonly competitionId: string

    readonly page?: number

    readonly pageSize?: number

    readonly totalPages?: number
}

/**
 * Request parameters for competitionApiGetCompetitionList operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompetitionListRequest {
    readonly endDate?: string

    readonly name?: string

    readonly ongoing?: string

    readonly pageNo?: string

    readonly pageSize?: string

    readonly startDate?: string
}

/**
 * Request parameters for competitionApiGetCompetitionPublishReadiness operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompetitionPublishReadinessRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiGetCompetitionRegistrations operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompetitionRegistrationsRequest {
    readonly competitionId: string

    readonly page?: number

    readonly pageSize?: number

    readonly searchQuery?: string | null

    readonly sortBy?: string | null

    readonly sortOrder?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for competitionApiGetCompetitionSchedules operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompetitionSchedulesRequest {
    readonly competitionId?: string

    readonly competitionScheduleId?: string

    readonly isActive?: string

    readonly pageNo?: number

    readonly pageSize?: number
}

/**
 * Request parameters for competitionApiGetCompetitionStartStatistics operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompetitionStartStatisticsRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiGetCompetitionSubmissions operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompetitionSubmissionsRequest {
    readonly competitionId: string

    readonly page?: number

    readonly pageSize?: number

    readonly sortBy?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for competitionApiGetCompetitionUserAnsweredQuestionsAnalytics operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetCompetitionUserAnsweredQuestionsAnalyticsRequest {
    readonly competitionId?: string

    readonly examId?: string

    readonly filterType?: string

    readonly page?: number

    readonly pageSize?: number

    readonly searchString?: string

    readonly skillIds?: Array<string>

    readonly userId?: string
}

/**
 * Request parameters for competitionApiGetDetailedCompetitionAnalyticsByUser operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetDetailedCompetitionAnalyticsByUserRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiGetInvites operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetInvitesRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiGetMySubmissions operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetMySubmissionsRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiGetPrivateAllCompetitions operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetPrivateAllCompetitionsRequest {
    readonly isRegistered?: boolean | null

    readonly lifecycle?: CompetitionApiGetPrivateAllCompetitionsLifecycleEnum

    readonly page?: string

    readonly pageSize?: string

    readonly searchQuery?: string

    readonly status?: string

    readonly typeOfCompetition?: CompetitionApiGetPrivateAllCompetitionsTypeOfCompetitionEnum
}

/**
 * Request parameters for competitionApiGetPublicCompetitionLeaderboard operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetPublicCompetitionLeaderboardRequest {
    readonly competitionId: string

    readonly pageSize?: number
}

/**
 * Request parameters for competitionApiGetPublicCompetitionSubmissions operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetPublicCompetitionSubmissionsRequest {
    readonly competitionId: string

    readonly page?: number

    readonly pageSize?: number

    readonly sortBy?: string | null

    readonly totalPages?: number
}

/**
 * Request parameters for competitionApiGetPublicSingleSubmission operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetPublicSingleSubmissionRequest {
    readonly competitionId: string

    readonly entryId: string
}

/**
 * Request parameters for competitionApiGetSingleSubmission operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetSingleSubmissionRequest {
    readonly competitionId: string

    readonly entryId: string
}

/**
 * Request parameters for competitionApiGetSubmissionTemplate operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetSubmissionTemplateRequest {
    readonly templateId: string
}

/**
 * Request parameters for competitionApiGetSubmissionTemplates operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetSubmissionTemplatesRequest {
    readonly includeArchived?: boolean

    readonly orgId?: string | null
}

/**
 * Request parameters for competitionApiGetUserCompetitionAchievements operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetUserCompetitionAchievementsRequest {
    readonly userId: string
}

/**
 * Request parameters for competitionApiGetUserReferralByCompetition operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiGetUserReferralByCompetitionRequest {
    readonly competitionId: string

    readonly pageNo?: number

    readonly pageSize?: number

    readonly totalPages?: number
}

/**
 * Request parameters for competitionApiInviteUsersCompetition operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiInviteUsersCompetitionRequest {
    readonly competitionId: string

    readonly competitionInvitationBody: CompetitionInvitationBody
}

/**
 * Request parameters for competitionApiIsCompetitionAliasAvailable operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiIsCompetitionAliasAvailableRequest {
    readonly alias: string
}

/**
 * Request parameters for competitionApiListCompetitionFaqs operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiListCompetitionFaqsRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiLockCompetition operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiLockCompetitionRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiPublicGetCompetitionById operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiPublicGetCompetitionByIdRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiRedeemCompetitionPremiumProfile operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiRedeemCompetitionPremiumProfileRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiRegenerateCompetitionInvites operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiRegenerateCompetitionInvitesRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiReorderCompetitionQuestionsMapping operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiReorderCompetitionQuestionsMappingRequest {
    readonly competitionId: string

    readonly reorderAssociatedQuestionsBody: ReorderAssociatedQuestionsBody
}

/**
 * Request parameters for competitionApiReplaceCompetitionQuestionV2 operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiReplaceCompetitionQuestionV2Request {
    readonly competitionId: string

    readonly replaceCompetitionQuestionBody: ReplaceCompetitionQuestionBody
}

/**
 * Request parameters for competitionApiResetCompetitionPublicContent operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiResetCompetitionPublicContentRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiResyncCompetitionCredits operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiResyncCompetitionCreditsRequest {
    readonly competitionId: string
}

/**
 * Request parameters for competitionApiReviewCompetitionEntries operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiReviewCompetitionEntriesRequest {
    readonly competitionId: string

    readonly adminUpdateRegistrationDetails: AdminUpdateRegistrationDetails
}

/**
 * Request parameters for competitionApiScoreShowcaseEntry operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiScoreShowcaseEntryRequest {
    readonly competitionId: string

    readonly entryId: string

    readonly scoreSubmissionBody: ScoreSubmissionBody
}

/**
 * Request parameters for competitionApiSetCalibrationSkills operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiSetCalibrationSkillsRequest {
    readonly competitionId: string

    readonly setCalibrationSkillsBody: SetCalibrationSkillsBody
}

/**
 * Request parameters for competitionApiSetCompetitionPublicListing operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiSetCompetitionPublicListingRequest {
    readonly competitionId: string

    readonly competitionPublicListingBody: CompetitionPublicListingBody
}

/**
 * Request parameters for competitionApiStartCalibrationSession operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiStartCalibrationSessionRequest {
    readonly competitionId: string

    readonly startCalibrationBody: StartCalibrationBody
}

/**
 * Request parameters for competitionApiToggleSubmissionLike operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiToggleSubmissionLikeRequest {
    readonly competitionId: string

    readonly entryId: string
}

/**
 * Request parameters for competitionApiUnlockCompetition operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiUnlockCompetitionRequest {
    readonly competitionId: string

    readonly unlockCompetitionBody: UnlockCompetitionBody
}

/**
 * Request parameters for competitionApiUpdateCompetitionFaq operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiUpdateCompetitionFaqRequest {
    readonly competitionId: string

    readonly faqId: string

    readonly upsertCompetitionFAQBody: UpsertCompetitionFAQBody
}

/**
 * Request parameters for competitionApiUpdateSubmissionTemplate operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiUpdateSubmissionTemplateRequest {
    readonly templateId: string

    readonly upsertSubmissionTemplateBody: UpsertSubmissionTemplateBody
}

/**
 * Request parameters for competitionApiUploadCompetitionImages operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiUploadCompetitionImagesRequest {
    readonly competitionImageFile?: File

    readonly competitionHeaderFile?: File

    readonly mobileHeaderFile?: File
}

/**
 * Request parameters for competitionApiUpsertCompetition operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiUpsertCompetitionRequest {
    readonly upsertCompetitionBody: UpsertCompetitionBody
}

/**
 * Request parameters for competitionApiUpsertCompetitionContent operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiUpsertCompetitionContentRequest {
    readonly competitionId: string

    readonly upsertCompetitionContentBody: UpsertCompetitionContentBody
}

/**
 * Request parameters for competitionApiUpsertCompetitionSchedule operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiUpsertCompetitionScheduleRequest {
    readonly competitionId: string

    readonly upsertScheduleBody: UpsertScheduleBody
}

/**
 * Request parameters for competitionApiUpsertEventPreferences operation in CompetitionApiApi.
 */
export interface CompetitionApiApiCompetitionApiUpsertEventPreferencesRequest {
    readonly competitionId: string

    readonly eventPreferencesBody: EventPreferencesBody
}

/**
 * CompetitionApiApi - object-oriented interface
 */
export class CompetitionApiApi extends BaseAPI {
    /**
     * 
     * @param {CompetitionApiApiCompetitionApiAddAdminCompetitionQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiAddAdminCompetitionQuestions(requestParameters: CompetitionApiApiCompetitionApiAddAdminCompetitionQuestionsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiAddAdminCompetitionQuestions(requestParameters.competitionId, requestParameters.addCompetitionQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiAddCompetitionQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiAddCompetitionQuestions(requestParameters: CompetitionApiApiCompetitionApiAddCompetitionQuestionsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiAddCompetitionQuestions(requestParameters.competitionId, requestParameters.addCompetitionQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiAdminCompetitionCleanupScript(options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiAdminCompetitionCleanupScript(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiAiEnhanceCompetitionDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiAiEnhanceCompetitionDetails(requestParameters: CompetitionApiApiCompetitionApiAiEnhanceCompetitionDetailsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiAiEnhanceCompetitionDetails(requestParameters.aIEnhanceCompetitionDetailsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiAssociateManualQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiAssociateManualQuestions(requestParameters: CompetitionApiApiCompetitionApiAssociateManualQuestionsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiAssociateManualQuestions(requestParameters.competitionId, requestParameters.reorderAssociatedQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiBanCompetitionUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiBanCompetitionUser(requestParameters: CompetitionApiApiCompetitionApiBanCompetitionUserRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiBanCompetitionUser(requestParameters.competitionId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiCompetitionRegistrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiCompetitionRegistrations(requestParameters: CompetitionApiApiCompetitionApiCompetitionRegistrationsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiCompetitionRegistrations(requestParameters.competitionId, requestParameters.competitionRegistrationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiCompetitionRegistrationsEntrySubmitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiCompetitionRegistrationsEntrySubmit(requestParameters: CompetitionApiApiCompetitionApiCompetitionRegistrationsEntrySubmitRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiCompetitionRegistrationsEntrySubmit(requestParameters.competitionId, requestParameters.title, requestParameters.description, requestParameters.projectUrl, requestParameters.projectFile, requestParameters.submissionData, requestParameters.sessionId, requestParameters.entryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiCreateCompetitionFaqRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiCreateCompetitionFaq(requestParameters: CompetitionApiApiCompetitionApiCreateCompetitionFaqRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiCreateCompetitionFaq(requestParameters.competitionId, requestParameters.upsertCompetitionFAQBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiCreateCompetitionMatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiCreateCompetitionMatch(requestParameters: CompetitionApiApiCompetitionApiCreateCompetitionMatchRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiCreateCompetitionMatch(requestParameters.generateCompetitionProfileMatchBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiCreateSubmissionTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiCreateSubmissionTemplate(requestParameters: CompetitionApiApiCompetitionApiCreateSubmissionTemplateRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiCreateSubmissionTemplate(requestParameters.upsertSubmissionTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiDeleteAssociatedQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiDeleteAssociatedQuestions(requestParameters: CompetitionApiApiCompetitionApiDeleteAssociatedQuestionsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiDeleteAssociatedQuestions(requestParameters.competitionId, requestParameters.deleteAssociatedQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiDeleteCompetitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiDeleteCompetition(requestParameters: CompetitionApiApiCompetitionApiDeleteCompetitionRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiDeleteCompetition(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiDeleteCompetitionFaqRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiDeleteCompetitionFaq(requestParameters: CompetitionApiApiCompetitionApiDeleteCompetitionFaqRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiDeleteCompetitionFaq(requestParameters.competitionId, requestParameters.faqId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiDeleteCompetitionScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiDeleteCompetitionSchedule(requestParameters: CompetitionApiApiCompetitionApiDeleteCompetitionScheduleRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiDeleteCompetitionSchedule(requestParameters.scheduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiDeleteSubmissionTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiDeleteSubmissionTemplate(requestParameters: CompetitionApiApiCompetitionApiDeleteSubmissionTemplateRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiDeleteSubmissionTemplate(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGenerateCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGenerateCertificate(requestParameters: CompetitionApiApiCompetitionApiGenerateCertificateRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGenerateCertificate(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGenerateCompetitionQuestionsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGenerateCompetitionQuestionsV2(requestParameters: CompetitionApiApiCompetitionApiGenerateCompetitionQuestionsV2Request, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGenerateCompetitionQuestionsV2(requestParameters.competitionId, requestParameters.generateCompetitionQuestionsV2Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetAdminCompetitionQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetAdminCompetitionQuestions(requestParameters: CompetitionApiApiCompetitionApiGetAdminCompetitionQuestionsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetAdminCompetitionQuestions(requestParameters.competitionId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetAllCompetitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetAllCompetitions(requestParameters: CompetitionApiApiCompetitionApiGetAllCompetitionsRequest = {}, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetAllCompetitions(requestParameters.isRegistered, requestParameters.lifecycle, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.status, requestParameters.typeOfCompetition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCalibrationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCalibrationStatus(requestParameters: CompetitionApiApiCompetitionApiGetCalibrationStatusRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCalibrationStatus(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCertificateDetailsByAliasRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCertificateDetailsByAlias(requestParameters: CompetitionApiApiCompetitionApiGetCertificateDetailsByAliasRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCertificateDetailsByAlias(requestParameters.certificateAlias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompactCompetitionAnalyticsByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompactCompetitionAnalyticsByUser(requestParameters: CompetitionApiApiCompetitionApiGetCompactCompetitionAnalyticsByUserRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompactCompetitionAnalyticsByUser(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompetitionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompetitionById(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionByIdRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompetitionById(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompetitionContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompetitionContent(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionContentRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompetitionContent(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompetitionContentBriefRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompetitionContentBrief(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionContentBriefRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompetitionContentBrief(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompetitionLeaderboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompetitionLeaderboard(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionLeaderboardRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompetitionLeaderboard(requestParameters.competitionId, requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompetitionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompetitionList(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionListRequest = {}, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompetitionList(requestParameters.endDate, requestParameters.name, requestParameters.ongoing, requestParameters.pageNo, requestParameters.pageSize, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompetitionPublishReadinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompetitionPublishReadiness(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionPublishReadinessRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompetitionPublishReadiness(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompetitionRegistrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompetitionRegistrations(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionRegistrationsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompetitionRegistrations(requestParameters.competitionId, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompetitionSchedulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompetitionSchedules(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionSchedulesRequest = {}, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompetitionSchedules(requestParameters.competitionId, requestParameters.competitionScheduleId, requestParameters.isActive, requestParameters.pageNo, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompetitionStartStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompetitionStartStatistics(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionStartStatisticsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompetitionStartStatistics(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompetitionSubmissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompetitionSubmissions(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionSubmissionsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompetitionSubmissions(requestParameters.competitionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetCompetitionUserAnsweredQuestionsAnalyticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetCompetitionUserAnsweredQuestionsAnalytics(requestParameters: CompetitionApiApiCompetitionApiGetCompetitionUserAnsweredQuestionsAnalyticsRequest = {}, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetCompetitionUserAnsweredQuestionsAnalytics(requestParameters.competitionId, requestParameters.examId, requestParameters.filterType, requestParameters.page, requestParameters.pageSize, requestParameters.searchString, requestParameters.skillIds, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetDetailedCompetitionAnalyticsByUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetDetailedCompetitionAnalyticsByUser(requestParameters: CompetitionApiApiCompetitionApiGetDetailedCompetitionAnalyticsByUserRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetDetailedCompetitionAnalyticsByUser(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetInvites(requestParameters: CompetitionApiApiCompetitionApiGetInvitesRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetInvites(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetMySubmissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetMySubmissions(requestParameters: CompetitionApiApiCompetitionApiGetMySubmissionsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetMySubmissions(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetPrivateAllCompetitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetPrivateAllCompetitions(requestParameters: CompetitionApiApiCompetitionApiGetPrivateAllCompetitionsRequest = {}, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetPrivateAllCompetitions(requestParameters.isRegistered, requestParameters.lifecycle, requestParameters.page, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.status, requestParameters.typeOfCompetition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetPublicCompetitionLeaderboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetPublicCompetitionLeaderboard(requestParameters: CompetitionApiApiCompetitionApiGetPublicCompetitionLeaderboardRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetPublicCompetitionLeaderboard(requestParameters.competitionId, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetPublicCompetitionSubmissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetPublicCompetitionSubmissions(requestParameters: CompetitionApiApiCompetitionApiGetPublicCompetitionSubmissionsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetPublicCompetitionSubmissions(requestParameters.competitionId, requestParameters.page, requestParameters.pageSize, requestParameters.sortBy, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetPublicSingleSubmissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetPublicSingleSubmission(requestParameters: CompetitionApiApiCompetitionApiGetPublicSingleSubmissionRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetPublicSingleSubmission(requestParameters.competitionId, requestParameters.entryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetSingleSubmissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetSingleSubmission(requestParameters: CompetitionApiApiCompetitionApiGetSingleSubmissionRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetSingleSubmission(requestParameters.competitionId, requestParameters.entryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetSubmissionTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetSubmissionTemplate(requestParameters: CompetitionApiApiCompetitionApiGetSubmissionTemplateRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetSubmissionTemplate(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetSubmissionTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetSubmissionTemplates(requestParameters: CompetitionApiApiCompetitionApiGetSubmissionTemplatesRequest = {}, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetSubmissionTemplates(requestParameters.includeArchived, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetUserCompetitionAchievementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetUserCompetitionAchievements(requestParameters: CompetitionApiApiCompetitionApiGetUserCompetitionAchievementsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetUserCompetitionAchievements(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiGetUserReferralByCompetitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiGetUserReferralByCompetition(requestParameters: CompetitionApiApiCompetitionApiGetUserReferralByCompetitionRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiGetUserReferralByCompetition(requestParameters.competitionId, requestParameters.pageNo, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiInviteUsersCompetitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiInviteUsersCompetition(requestParameters: CompetitionApiApiCompetitionApiInviteUsersCompetitionRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiInviteUsersCompetition(requestParameters.competitionId, requestParameters.competitionInvitationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiIsCompetitionAliasAvailableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiIsCompetitionAliasAvailable(requestParameters: CompetitionApiApiCompetitionApiIsCompetitionAliasAvailableRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiIsCompetitionAliasAvailable(requestParameters.alias, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiListCompetitionFaqsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiListCompetitionFaqs(requestParameters: CompetitionApiApiCompetitionApiListCompetitionFaqsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiListCompetitionFaqs(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiLockCompetitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiLockCompetition(requestParameters: CompetitionApiApiCompetitionApiLockCompetitionRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiLockCompetition(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiPublicGetCompetitionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiPublicGetCompetitionById(requestParameters: CompetitionApiApiCompetitionApiPublicGetCompetitionByIdRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiPublicGetCompetitionById(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiRedeemCompetitionPremiumProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiRedeemCompetitionPremiumProfile(requestParameters: CompetitionApiApiCompetitionApiRedeemCompetitionPremiumProfileRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiRedeemCompetitionPremiumProfile(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiRegenerateCompetitionInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiRegenerateCompetitionInvites(requestParameters: CompetitionApiApiCompetitionApiRegenerateCompetitionInvitesRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiRegenerateCompetitionInvites(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiReorderCompetitionQuestionsMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiReorderCompetitionQuestionsMapping(requestParameters: CompetitionApiApiCompetitionApiReorderCompetitionQuestionsMappingRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiReorderCompetitionQuestionsMapping(requestParameters.competitionId, requestParameters.reorderAssociatedQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiReplaceCompetitionQuestionV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiReplaceCompetitionQuestionV2(requestParameters: CompetitionApiApiCompetitionApiReplaceCompetitionQuestionV2Request, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiReplaceCompetitionQuestionV2(requestParameters.competitionId, requestParameters.replaceCompetitionQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiResetCompetitionPublicContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiResetCompetitionPublicContent(requestParameters: CompetitionApiApiCompetitionApiResetCompetitionPublicContentRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiResetCompetitionPublicContent(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiResyncCompetitionCreditsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiResyncCompetitionCredits(requestParameters: CompetitionApiApiCompetitionApiResyncCompetitionCreditsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiResyncCompetitionCredits(requestParameters.competitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiReviewCompetitionEntriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiReviewCompetitionEntries(requestParameters: CompetitionApiApiCompetitionApiReviewCompetitionEntriesRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiReviewCompetitionEntries(requestParameters.competitionId, requestParameters.adminUpdateRegistrationDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiScoreShowcaseEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiScoreShowcaseEntry(requestParameters: CompetitionApiApiCompetitionApiScoreShowcaseEntryRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiScoreShowcaseEntry(requestParameters.competitionId, requestParameters.entryId, requestParameters.scoreSubmissionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiSendCertificate(options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiSendCertificate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiSetCalibrationSkillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiSetCalibrationSkills(requestParameters: CompetitionApiApiCompetitionApiSetCalibrationSkillsRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiSetCalibrationSkills(requestParameters.competitionId, requestParameters.setCalibrationSkillsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiSetCompetitionPublicListingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiSetCompetitionPublicListing(requestParameters: CompetitionApiApiCompetitionApiSetCompetitionPublicListingRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiSetCompetitionPublicListing(requestParameters.competitionId, requestParameters.competitionPublicListingBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiStartCalibrationSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiStartCalibrationSession(requestParameters: CompetitionApiApiCompetitionApiStartCalibrationSessionRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiStartCalibrationSession(requestParameters.competitionId, requestParameters.startCalibrationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiToggleSubmissionLikeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiToggleSubmissionLike(requestParameters: CompetitionApiApiCompetitionApiToggleSubmissionLikeRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiToggleSubmissionLike(requestParameters.competitionId, requestParameters.entryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiUnlockCompetitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiUnlockCompetition(requestParameters: CompetitionApiApiCompetitionApiUnlockCompetitionRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiUnlockCompetition(requestParameters.competitionId, requestParameters.unlockCompetitionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiUpdateCompetitionFaqRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiUpdateCompetitionFaq(requestParameters: CompetitionApiApiCompetitionApiUpdateCompetitionFaqRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiUpdateCompetitionFaq(requestParameters.competitionId, requestParameters.faqId, requestParameters.upsertCompetitionFAQBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiUpdateSubmissionTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiUpdateSubmissionTemplate(requestParameters: CompetitionApiApiCompetitionApiUpdateSubmissionTemplateRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiUpdateSubmissionTemplate(requestParameters.templateId, requestParameters.upsertSubmissionTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiUploadCompetitionImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiUploadCompetitionImages(requestParameters: CompetitionApiApiCompetitionApiUploadCompetitionImagesRequest = {}, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiUploadCompetitionImages(requestParameters.competitionImageFile, requestParameters.competitionHeaderFile, requestParameters.mobileHeaderFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiUpsertCompetitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiUpsertCompetition(requestParameters: CompetitionApiApiCompetitionApiUpsertCompetitionRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiUpsertCompetition(requestParameters.upsertCompetitionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiUpsertCompetitionContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiUpsertCompetitionContent(requestParameters: CompetitionApiApiCompetitionApiUpsertCompetitionContentRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiUpsertCompetitionContent(requestParameters.competitionId, requestParameters.upsertCompetitionContentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiUpsertCompetitionScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiUpsertCompetitionSchedule(requestParameters: CompetitionApiApiCompetitionApiUpsertCompetitionScheduleRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiUpsertCompetitionSchedule(requestParameters.competitionId, requestParameters.upsertScheduleBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompetitionApiApiCompetitionApiUpsertEventPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public competitionApiUpsertEventPreferences(requestParameters: CompetitionApiApiCompetitionApiUpsertEventPreferencesRequest, options?: RawAxiosRequestConfig) {
        return CompetitionApiApiFp(this.configuration).competitionApiUpsertEventPreferences(requestParameters.competitionId, requestParameters.eventPreferencesBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const CompetitionApiGetAllCompetitionsLifecycleEnum = {
    Draft: 'draft',
    Lapsed: 'lapsed',
    Scheduled: 'scheduled',
    Live: 'live',
    Finished: 'finished',
} as const;
export type CompetitionApiGetAllCompetitionsLifecycleEnum = typeof CompetitionApiGetAllCompetitionsLifecycleEnum[keyof typeof CompetitionApiGetAllCompetitionsLifecycleEnum];
export const CompetitionApiGetAllCompetitionsTypeOfCompetitionEnum = {
    SnapQuiz: 'SnapQuiz',
    Showcase: 'Showcase',
    CodeIt: 'CodeIt',
    JobChallenge: 'JobChallenge',
} as const;
export type CompetitionApiGetAllCompetitionsTypeOfCompetitionEnum = typeof CompetitionApiGetAllCompetitionsTypeOfCompetitionEnum[keyof typeof CompetitionApiGetAllCompetitionsTypeOfCompetitionEnum];
export const CompetitionApiGetPrivateAllCompetitionsLifecycleEnum = {
    Draft: 'draft',
    Lapsed: 'lapsed',
    Scheduled: 'scheduled',
    Live: 'live',
    Finished: 'finished',
} as const;
export type CompetitionApiGetPrivateAllCompetitionsLifecycleEnum = typeof CompetitionApiGetPrivateAllCompetitionsLifecycleEnum[keyof typeof CompetitionApiGetPrivateAllCompetitionsLifecycleEnum];
export const CompetitionApiGetPrivateAllCompetitionsTypeOfCompetitionEnum = {
    SnapQuiz: 'SnapQuiz',
    Showcase: 'Showcase',
    CodeIt: 'CodeIt',
    JobChallenge: 'JobChallenge',
} as const;
export type CompetitionApiGetPrivateAllCompetitionsTypeOfCompetitionEnum = typeof CompetitionApiGetPrivateAllCompetitionsTypeOfCompetitionEnum[keyof typeof CompetitionApiGetPrivateAllCompetitionsTypeOfCompetitionEnum];
